export const transformTaskToRequest = (task) => ({
    title: task.title,
    description: task.description,
    ref_fonciere: task.ref_fonciere,
    ville_id: task.ville_id,
    adresse: task.adresse,
    due_date: task.due_date,
    priority: task.priority?.code,
    status: task.status?.code,
    created_by: task.created_by,
    project_id: task.project_id,
    project_label: task.project_label,
    client_id: task.client_id,
    parent_id: task.parent_id,
    missions: task.taskMissions,
    charges: task.taskCharges,
    assignees: task.assignees,
    travels: task.travels,
});
export const transformUserToRequest = (user) => {
    const roleId = user.role_id ?? user.role?.id;
    if (roleId === undefined || roleId === null) {
        throw new Error("role_id is required to transform user to request");
    }
    return {
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        role_id: roleId,
        indic_actif: user.indic_actif === 1, // Convertir en booléen
        manager_id: user.manager_id ?? user.manager?.id ?? null,
    };
};
export const transformToRequestClient = (client) => ({
    denomination: client.denomination,
    ice: client.ice,
    client_type: client.client_type,
    telephone: client.telephone,
    email: client.email,
    ville_id: client.ville_id,
    adresse: client.adresse,
    indic_actif: client.indic_actif,
});
export const transformToRequestProject = (project) => ({
    label: project.label,
    contract_type_id: project.contract_type_id,
    ref_fonciere: project.ref_fonciere,
    ref_contrat: project.ref_contrat,
    client_id: project.client_id,
    ville_id: project.ville_id,
    adresse: project.adresse,
    is_active: project.is_active,
});
